export const ROLLOUTS = {
    QUALAS_NEW_LEVEL_SYSTEM: 'qualas_new_level_system_consumers_migration',
    LYNXES_USER_QUESTIONNAIRE_ROUTING: 'lynxes_user_questionnaire_routing',
    HAWKS_AI_STORE_BUILDER_LIHP: 'hawks_ai_store_builder_lihp',
    CHAMS_DUMMY_SEGMENTATION_JP: 'chams_dummy_segmentation_jp',
    MUSTANGS_PERSON_BRIEF: 'mustangs_person_brief',
    LYNXES_JP_HIGH_SPEND_POTENTIAL: 'lynxes_jp_high_spend_potential',
    MUSTANGS_PERSON_BRIEF_LAYOUT: 'mustangs_person_brief_layout',
    PIGLETS_ENABLE_PRICE_UPFRONT: 'piglets_enable_price_upfront_display',
    LYNXES_SCREENING_QUESTIONS_BRIEFS_LOBBY: 'lynxes_screening_questions_briefs_lobby',
    PANTHERS_HOMEPAGE_UNREAD_COUNTERS_FROM_KIMERA: 'panthers_homepage_unread_counters_route_from_kimera',
    CHEETAHS_BOOK_PUBLISHING: 'cheetahs_book_publishing',
} as const;
